import { useStorage } from "@vueuse/core";

const STORAGE_KEY = "bubble_shown";

function getCurrentUserId(): string {
  return localStorage.getItem("userId") || "";
}

const bubbleShownArr = useStorage<string[]>(STORAGE_KEY, []);

// 内存备份
let bubbleShownBackup: string[] = [...bubbleShownArr.value];

function hasSeenBubble(userId?: string): boolean {
  const uid = userId || getCurrentUserId();
  return bubbleShownArr.value.includes(uid);
}

function markBubbleShown(userId?: string) {
  const uid = userId || getCurrentUserId();
  if (!bubbleShownArr.value.includes(uid)) {
    bubbleShownArr.value.push(uid);
    bubbleShownBackup.push(uid);
  }
}

function restoreBubbleCache() {
  bubbleShownArr.value = [...bubbleShownBackup];
}

function syncBackup() {
  bubbleShownBackup = [...bubbleShownArr.value];
}

// ✅ 封装清除 localStorage 但保留引导缓存
function safeClearStorage() {
  let isClickNextArr = localStorage.getItem('isClickNextArr')
  let userPhone = localStorage.getItem('phone')
  sessionStorage.setItem('isClickNextArr', isClickNextArr ?? '[]')
  sessionStorage.setItem('phone', userPhone ?? '')
  
  syncBackup();
  localStorage.clear();
  restoreBubbleCache();
  localStorage.setItem('isClickNextArr', sessionStorage.getItem('isClickNextArr') || '[]')
  localStorage.setItem('phone', sessionStorage.getItem('phone') || '')
  sessionStorage.removeItem('isClickNextArr')
  sessionStorage.removeItem('phone')
}

export function useBubbleGuide() {
  return {
    getCurrentUserId,
    hasSeenBubble,
    markBubbleShown,
    restoreBubbleCache,
    syncBackup,
    safeClearStorage,
  };
}
